import { ModuleWithProviders, NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { NotificationBodyComponent } from './notification-body/notification-body.component';
import { NotificationData } from './notification-data';
import { NotificationHostComponent } from './notification-host/notification-host.component';
import { NotificationsContainerComponent } from './notifications-container/notifications-container.component';
import { NotificationsGroupComponent } from './notifications-group/notifications-group.component';
import { NotificationsController } from './notifications.controller';
import { TextSwapComponent } from './text-swap.component';

@NgModule({
  imports: [RtUICommonModule],
  declarations: [
    NotificationBodyComponent,
    NotificationsContainerComponent,
    NotificationsGroupComponent,
    NotificationHostComponent,
    TextSwapComponent,
  ],
  exports: [NotificationHostComponent, TextSwapComponent],
})
export class RtUINotificationsModule {
  public static forRoot(): ModuleWithProviders<RtUINotificationsModule> {
    return {
      ngModule: RtUINotificationsModule,
      providers: [NotificationsController, NotificationData],
    };
  }
}

export {
  NotificationsController,
  NotificationHostComponent,
  NotificationsContainerComponent,
  NotificationsGroupComponent,
  TextSwapComponent,
};
export { NotificationBodyBase } from './notification-body-base';
export { NotificationHostBase } from './notification-host-base';
export * from './notification-config';
export * from './notification-ref';
export * from './notification-group-ref';
export * from './notification-data';
export { NotificationType } from './notifications.controller';
